<template lang="pug">
f7-page#terms-of-use
  background
    section
      h3 第1条(目的)
      p 本規約は、株式会社だんきち(以下「当社」といいます。)が提供するサービスである「スポともダンス」(以下「本アプリ」といいます。)の利⽤条件について規定するものであり、本アプリを利⽤するにあたり適⽤されます。

    section
      h3 第2条(定義)
      p 本規約における⽤語の定義は次のとおりとします。
      p 1.「本アプリ」とは、当社が提供するアプリケーション「スポともダンス」をいいます。
      p 2.「利用者」とは、当社所定の手続きに従い、本規約及び当社が別途定める各規程を確認の上、本アプリの利用申込みをされた方で、かつ、当社がそれを認めてログインIDを付与し、利用者登録した方をいいます。なお、本アプリは、当社との間で別途合意をした場合を除き、自然人のみ利用者登録が可能であり、法人による利用者登録はできません。また、当社サポートスタッフによる場合を除き、代理による登録もできません。
      p 3.「ログインID」とは、本アプリの利用者登録時に当社が付与、又は利用者が設定する英数字と記号の組合せをいいます。
      p 4.「パスワード」とは、本アプリの利用申込み時に利用者自らが設定する英数字をいいます。
      p 5.「コーチ」とは、上記「利用者」の中で、本サービスのシステムを利用してコーチングや指導等の役務を提供する者をいいます。

    section
      h3 第3条(利用者情報の変更)
      p 1.利用者は、利用者が当社に届け出た氏名・電話番号等の情報について変更があった場合には、当社所定の方法により遅滞なく当社に届け出るものとします。
      p 2.前項の変更にかかる届出がなされなかったことにより利用者に生じた不利益又は損害について、当社は、その責任を負わないものとします。

    section
      h3 第4条(ログインID及びパスワードの管理等)
      p 1.利用者は、ログインID及びパスワード(以下「パスワード等」といいます。)を他人に知られないように善良な管理者の注意をもって管理するものとします。
      p 2.利用者は、パスワード等を第三者に利用させたり、貸与、譲渡、売買、質入等をすることはできないものとします。
      p 3.利用者は、パスワード等を自己の責任において厳重に管理し、第三者への漏洩を防ぐものとします。パスワード等の漏洩、不正使用等を原因として生じた不利益又は損害について、当社は、一切の責任を負わないものとします。
      p
        | 4.利用者は、パスワード等を忘れた場合又はパスワード等が第三者に使用されたことが判明した場合には、直ちに当社のご相談窓口(
        a(class="external" href="mailto:spotomo_support@dank-1.com") spotomo_support@dank-1.com
        | )に連絡の上、当社の指示に従うものとします。

    section
      h3 第5条(未成年による利用)
      p お客様が未成年者である場合は、親権者など法定代理人の同意(本規約への同意を含みます)を得た上で本サービスを利用してください。また、本契約に同意した時点で未成年者であったお客様が、成年に達した後に本サービスを利用した場合、未成年者であった間の利用行為を追認したものとみなします。

    section
      h3 第6条(利用料金の支払い)
      p 1.利用者は、本アプリの利用にかかる料金として、当社が定めた方法により、当社が定めた金額を支払うものとします。
      p 2.月額料金プランの課金は、解約手続きまたは料金プランの変更を行わない限り、自動的に継続されます。
      p (1)カード決済の解約の際は、本アプリ内のお支払い情報から解約するを押下し、継続決済の解除を行ってください。当月24日までに解約手続きをとられた場合は、当月末日で解約するものとし、翌月分の月額料金は発生しません。当月25日以降に解約手続きをとられた場合は、翌月末日で解約するものとし、翌月分の月額料金が発生します。
      p (2)口座振替の解約の際は、本アプリ内のチャットからサポートセンターを選択し、当社までお知らせください。当月15日までに解約手続きをとられた場合は、当月末日で解約するものとし、翌月分の月額料金は発生しません。当月16日以降に解約手続きをとられた場合は、翌月末日で解約するものとし、翌月分の月額料金が発生します。
      h3 第6条の2(初月無料キャンペーン)
      p 1.当社は、一定の条件を満たす新規ユーザーに対し、初回登録後に提供される無料体験レッスンの終了日を起点として、その月の月末日まで、月額利用料金が無料となる「初月無料キャンペーン」（以下「本キャンペーン」といいます）を実施することがあります。
      p 2.本キャンペーンの対象は、キャンペーン実施期間中に新規登録したユーザーに限ります。
      p 3.本キャンペーンを利用したユーザーは、無料期間の終了後から起算して6か月間は、いかなる理由によってもサービスの退会（契約解除）を行うことはできません。本キャンペーン期間満了後に退会の申請が可能となります。やむを得ず本キャンペーン期間中に退会を希望する場合は、本キャンペーン残期間に応じた月額レッスン料の残額を違約金として一括で支払うものとします。
      p 4.本キャンペーンの内容は、予告なく変更または終了することがあります。
      p 5.その他の条件は、当社が別途定めるキャンペーンページの記載に従うものとします。

    section
      h3 第7条(本アプリが利用できない場合)
      p 利用者は、次に掲げる場合には本アプリを利用できない場合があります。
      p (1)本アプリのシステムに故障が生じた場合及びシステム保守管理等のために当該システムの全部又は一部を、定期的に又は緊急に休止する場合
      p (2)本アプリの運用・提供に必要な機器等の破損、火災・停電その他の事由による使用不能の場合
      p (3)天変地異、戦争、内覧、暴動その他の不可抗力により、本アプリの提供ができなくなった場合
      p (4)その他運用上又は技術上、本アプリの一時的な中断が必要であると当社が判断した場合

    section
      h3 第8条(禁止事項)
      p 利用者は、次の各号に掲げる行為を行ってはならないものとします。
      p (1)公序良俗に反する行為
      p (2)法令に反する行為
      p (3)犯罪的行為を助長する行為
      p (4)他の利用者又は第三者の著作権、特許権、実用新案権、意匠権、商標権、その他の知的財産権を侵害する行為及び財産、信用、名誉、プライバシーを侵害する行為
      p (5)他の利用者又は第三者に不利益を与える行為
      p (6)本アプリの運用を妨げ、又は当社の信用を毀損する行為
      p (7)他人を欺くことを目的とした、虚偽や事実と異なる情報の登録やなりすまし行為
      p (8)パスワード等を不正に使用する行為
      p (9)本アプリを営利目的で利用する行為
      p (10)本アプリ(本アプリにおいて提供される情報を含みます。)を不正に利用する行為
      p (11)本アプリにおいてコーチから提供された指導コメント及び動画等を、許可なくインターネット上にアップロードし、又は不特定多数の第三者が閲覧可能な環境に置くこと
      p (12)コーチに対して、本アプリ及び指導内容とは関係の無いメッセージを送り、又は、コーチの私的な連絡先を聞き出すこと
      p (13)本アプリに関連するデータの不正な改ざん、プラットフォームやアプリケーション等の改変、逆アセンブル、逆コンパイル及びリバースエンジニアリング、並びにこれらに類する全ての行為及びこれらにより本アプリを不正に利用する行為
      p (14)本アプリについて虚偽又は誤認を生じさせるような情報等を、インターネット上に掲載し、又はその他の手段により不特定多数の第三者が閲覧可能な環境に置くこと
      p (15)本アプリに関して当社が提供するアプリケーション及びプラットフォーム以外の手段で、本アプリ又は対象コンテンツにアクセスする行為又はアクセスを試みる行為
      p (16)本アプリを利用した選挙の事前運動、選挙運動又はこれらに類する行為及び公職選挙法に抵触する行為
      p (17)未成年者の人格形成等に悪影響を与えると判断される行為
      p (18)本規約に違反する行為
      p (19)その他当社が不適切と判断する行為

    section
      h3 第9条(反社会的勢力の排除)
      p 1.利用者は、申込みの時点において、暴力団、暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者（以下、これらを「反社会的勢力」という。）のいずれにも該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ、将来にわたっても該当しないことを確約します。
      p (1)反社会的勢力が事業経営を支配し、または事業経営に実質的に関与していると認められる関係を有すること
      p (2)自己もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること
      p (3)反社会的勢力に対して資金等を提供し、または便宜を供与するなどの関与をし、反社会的勢力の維持運営に積極的に協力していると認められる関係を有すること
      p (4)反社会的勢力と社会的に非難されるべき関係を有すること
      p 2.利用者は、自らまたは第三者を利用して次の各号の一にでも該当する行為を行わないことを確約する。
      p (1)暴力的な要求行為
      p (2)法的な責任を超えた不当な要求行為
      p (3)取引に関して、脅迫的な言動をし、または暴力を用いる行為
      p (4)風説を流布し、偽計を用いまたは威力を用いて相手方の信用を毀損し、または相手方の業務を妨害する行為
      p (5)その他前各号に準ずる行為

    section
      h3 第10条(退会及び利用者資格の喪失)
      p 1.利⽤者は、当社所定の⼿続きを⾏うことにより、退会できるものとします。退会⼿続完了と同時に利⽤者資格が喪失され、本アプリの利⽤ができなくなります。
      p 2.前項にかかわらず、利⽤者が次のいずれかに該当する場合、当社の判断により利⽤者資格を取り消すことができるものとします。この場合、当社は、事前の通知⼜は催告を要せず、利⽤者による本アプリの利⽤を直ちに中⽌させることができるものとします。
      p (1)利⽤申込みの際に記載した事項が事実と異なる場合(記載時においては事実と合致していたが、その後変更があった場合において、当社に対する変更の届出が合理的な期間内になされない場合を含みます。)
      p (2)利⽤者がその責に帰すべき事由により過去に本アプリの利⽤者資格を取り消されたことが判明した場合⼜は当社が提供する他のサービスについてユーザー登録等が抹消され若しくは過去に抹消されたことが判明した場合
      p (3)第6条1項に基づく利用料金の支払を怠った場合
      p (4)その他、利⽤者が本規約に違反した場合
      p (5)利用者が反社会的勢力もしくは第9条第１項各号のいずれかに該当し、または同項の規定にもとづく表明・確約が虚偽であることが判明した場合、もしくは同条第2項各号のいずれかに該当する行為をした場合
      p (6)上記に準ずる⾏為があり、当社が利⽤者として不適格と判断した場合

    section
      h3 第11条(個人情報等の収集・利用)
      p 当社は、当社の定めるプライバシーポリシーにのっとって、個⼈情報等を取り扱うものとします。詳細は、当社ホームページ（リンクはページ最下部に記載）をご参照ください。
      p 利⽤者(本条においては、本アプリの利⽤申込みをしようとする⽅を含みます。)は、本アプリの利用前に、当社の定めるプライバシ―ポリシーを必ず確認し、その内容に同意した上で本アプリを利用するものとします。
      p 当社は、利⽤者が第9条第1項に従い本アプリを退会した後であっても、期限なく当該利⽤者にかかる個⼈情報等を保有及び利⽤します。

    section
      h3 第12条(本規約の変更)
      p 当社は、本規約の内容を変更することができるものとします。当社は、本規約の内容を変更した場合、効力発生時期を定めて当社ホームページ上で公表し、本規約の内容の変更は、その効力発生時期が到来したときにその効力を生じるものとします。この場合、利用者は、変更後の規約の内容に従うものとします。

    section
      h3 第13条(本アプリの終了)
      p 当社は、次のいずれかの場合には、利⽤者に対し事前に当社所定の⽅法で通知することにより、本アプリを全⾯的に終了することができるものとします。
      p (1)社会情勢の変化
      p (2)法令の改廃
      p (3)その他当社がやむを得ないと判断した場合

    section
      h3 第14条(注意事項)
      p 1.本アプリを利⽤したトレーニング等は、利⽤者の責任において⾏うものとし、未成年者が本アプリを利⽤する場合には、必ず保護責任者の監督のもとでトレーニング等を⾏ってください。
      p 2.当社は、利用者に対し、本アプリを通じて利用者がコーチから指導等を受ける機会をご提供するのみであり、コーチによる指導等の内容に関しては、指揮監督その他一切の関与をするものではありません。また、当社は、本アプリ上でコーチから利⽤者に対して提供される指導内容の安全性、正確性等を保証するものではなく、本アプリを利⽤することによる⼀定の成績・スコア等を達成し、⼜は当該スポーツ競技における上達を保証するものでもありません。

    section
      h3 第15条(免責事項)
      p 1.本アプリを利⽤したトレーニング等における事故、その他の事由により利⽤者⼜は第三者に損害が発⽣した場合であっても、当社及びコーチは、⼀切の責任を負いません。
      p 2.利用者とコーチとの間でトラブルが生じた際には、利用者とコーチとの間で解決していただくことになり、当社は、窓口としての対応や、解決のあっせん、仲裁等は一切行いません。なお、コーチの変更をご希望される場合には、当社所定の手続に従い、対応させていただきます。
      p 3.利用者が本規約に違反したことによって生じた損害については、当社は一切責任を負いません。
      p 4.当社は、利用者に対し、利用者の希望を踏まえてコーチを紹介することや、適宜情報提供、アドバイスを行うことがありますが、それにより責任を負うものではありません。
      p 5.通信回線やコンピュータなどの障害によるシステムの中断・遅滞・中⽌・データの消失、データへの不正アクセスにより⽣じた損害、その他当社のサービスに関して会員に⽣じた損害について、当社は⼀切責任を負わないものとします。
      p 6.当社は、当社のウェブページ・サーバ・ドメインなどから送られるメール・コンテンツに、コンピューター・ウィルスなどの有害なものが含まれていないことを保証いたしません。
      p 7.第７条若しくは前各項に定める事由⼜はその他の事由により、利⽤者が本アプリを利⽤することができず、⼜は本アプリの品質が低下したことで、当該利⽤者に⽣じた不利益⼜は損害について、当社は、その責任を負わないものとします。但し、当該不利益⼜は損害が当社の故意⼜は重⼤な過失による場合を除きます。

    section
      h3 第16条(通知の到達)
      p 当社が、利⽤者に対して通知を⾏うにあたり、電⼦メール等の⽅法による場合には、当社は利⽤者から届け出られた電⼦メールアドレス宛に通知を発送すれば⾜りるものとし、当該通知の到達が遅延し、⼜は到達しなかった場合においても、当社は通常到達するであろう時に到達したものとみなします。

    section
      h3 第17条(業務委託)
      p 当社は、本規約に基づく本アプリ運営管理業務について、業務の⼀部を第三者に委託することができるものとします。

    section
      h3 第18条(著作権等)
      p 本アプリを利⽤するために必要なアプリケーション、システム等に関する著作権その他の知的財産権等は、当社に帰属するものとします。

    section
      h3 第19条(管轄裁判所)
      p 利⽤者は、本アプリ及び本規約に基づく取引に関して、当社との間に紛争が⽣じた場合には、大阪地⽅裁判所を第⼀審の専属裁判所とすることを異議なく承諾するものとします。

    section
      h3 第20条(準拠法)
      p 本規約の成⽴、効⼒及び解釈に関しては、⽇本国法が適⽤されるものとします。

    .establish-date 2018年10月1日制定
    .establish-date 2019年9月30日改定
    .establish-date 2021年2月15日改訂
    .establish-date 2021年3月20日改訂
    .establish-date 2023年6月26日改訂
    .establish-date 2025年4月22日改訂

    section.links
      h3 リンク
      f7-link(@click="onClick") スポともダンス プライバシーポリシー
</template>

<style lang="scss" scoped>
@import '@/styles/public-common.scss';
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'

export default {
  mixins: [PageTitle],
  title: '利用規約',
  methods: {
    onClick() {
      var href = '/public/privacypolicy'
      if (location.pathname.match('(^/web)')) {
        href = `/web${href}`
      }
      location.href = href
    },
  },
}
</script>
